import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type Theme = 'system' | 'light' | 'dark';
export type WeightUnit = 'kg' | 'lb';

interface PrefsState {
  theme: Theme;
  weightUnit: WeightUnit;
  activeOrgId: string | null;
  /** Show only content scoped to the provider's certification level. */
  filterByLevel: boolean;
  protocolFontScale: number;
  setTheme: (theme: Theme) => void;
  setWeightUnit: (unit: WeightUnit) => void;
  setActiveOrgId: (id: string | null) => void;
  setFilterByLevel: (value: boolean) => void;
  setProtocolFontScale: (value: number) => void;
}

export const usePrefs = create<PrefsState>()(
  persist(
    (set) => ({
      theme: 'system',
      weightUnit: 'kg',
      activeOrgId: null,
      filterByLevel: false,
      protocolFontScale: 1,
      setTheme: (theme) => set({ theme }),
      setWeightUnit: (weightUnit) => set({ weightUnit }),
      setActiveOrgId: (activeOrgId) => set({ activeOrgId }),
      setFilterByLevel: (filterByLevel) => set({ filterByLevel }),
      setProtocolFontScale: (protocolFontScale) => set({ protocolFontScale: Math.min(1.5, Math.max(0.85, protocolFontScale)) }),
    }),
    { name: 'ems-prefs' },
  ),
);

export function applyTheme(theme: Theme) {
  const dark = theme === 'dark' || (theme === 'system' && window.matchMedia('(prefers-color-scheme: dark)').matches);
  document.documentElement.classList.toggle('dark', dark);
  document.querySelector('meta[name="theme-color"]')?.setAttribute('content', dark ? '#131211' : '#fafaf9');
}
